import { Box, FormControl } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import React, { FC } from "react";

import { GvCheckboxCustom } from "../../../styles/styledComponents";

interface ICheckboxControllerProps {
  id?: string;
  name: string;
  label: string | JSX.Element;
  control: Control<any>;
  fullWidth?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  alignType?: "start" | "center" | "end";
  checkboxClassName?:string;
  labelClassName?:string;
}

const GvCheckboxController: FC<ICheckboxControllerProps> = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  defaultChecked = false,
  disabled = false,
  alignType,
  checkboxClassName,
  labelClassName,
}) => {
  const fieldId = id || name;

  return (
    <FormControl fullWidth={fullWidth}>
      <Box sx={{ display: "flex", alignItems: alignType ? alignType : "center" }}>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultChecked}
          render={({ field, fieldState }) => (
            <>
              <GvCheckboxCustom
                id={fieldId}
                disabled={disabled}
                {...field}
                checked={field.value}
                color={!!fieldState.error ? "error" : "default"}
                className={checkboxClassName ? checkboxClassName : ""}
              />
              {label && (
                <label
                  className={`ml-2 text-sm
                     ${field.value ? "text-light-black" : "text-gray-1"}
                     ${disabled && "text-gray-1"} ${labelClassName}`}

                >
                  {label}
                </label>
              )}
            </>
          )}
        />
      </Box>
    </FormControl>
  );
};

export default GvCheckboxController;
